import {mapMutations, mapState} from "vuex";

export default {
    data () {
        return {
            isDisabled:true
        }
    },
    watch: {
        'form.code.value'(newVal){
            this.isDisabled = !newVal
        }
    },
  computed: {
    ...mapState('safe', ['accountInfo'])
  },
  methods: {
    ...mapMutations('safe', ['SET_ACCOUNTINFO'])
  }
}
